import { batch } from "react-redux";
import store from "../../store";

import { fetchGoogleWorkSheetService } from "./googleSheetServices";
import { updateDocumentComponentService } from "../DocumentActions/services";
import { gSheetToRevvTable } from "./methods";

export const setCurrentGSheetTab = sheet => {
  store.dispatch({
    type: "CURRENT_G_SHEET_TAB",
    payload: sheet,
  });
};

export const fetchGoogleWorkSheet = (
  sheet,
  name,
  sectionID,
  firstRowAsHeader,
  resync,
  dataRange,
) => dispatch =>
  new Promise((resolve, reject) => {
    let dataRangeEntry = "";
    if (dataRange) {
      dataRangeEntry = `&range=${dataRange}`;
    }
    fetchGoogleWorkSheetService(sheet.id, name, resync, dataRangeEntry)
      .then(response => {
        const {
          sheetTableData,
          columnCount,
          originalColumnCount,
        } = gSheetToRevvTable(response, firstRowAsHeader);
        const reduxState = store.getState();
        const { components = {} } = reduxState.DocumentStore;
        const gSheetSection = components[sectionID]
          ? components[sectionID].content
          : null;
        const sheetData = Object.assign({}, gSheetSection.data, {
          attributes: { columnCount, originalColumnCount },
          data: sheetTableData,
        });
        gSheetSection.data = sheetData;
        gSheetSection.rangeValue = response.DataRange;
        gSheetSection.autoTrim = response.AutoTrim;
        gSheetSection.workSheet = response.SheetData.sheets[0].properties.title;
        gSheetSection.sheet = sheet;
        gSheetSection.connected = true;
        gSheetSection.firstRowAsHeader = firstRowAsHeader;
        batch(() => {
          dispatch({
            type: "UPDATE_GSHEET_TABLES",
            payload: {
              sectionID,
              tableSection: gSheetSection,
            },
          });
          dispatch({
            type: "CURRENT_G_SHEET_TAB",
            payload: gSheetSection,
          });
          dispatch({
            type: "UPDATE_GSHEET_SECTION",
            payload: {
              sectionID,
              sectionData: sheetTableData,
              sheet,
              workSheet: response.SheetData.sheets[0].properties.title,
              rangeValue: response.DataRange,
              autoTrim: response.AutoTrim,
              firstRowAsHeader,
            },
          });
        });
        if (gSheetSection) {
          updateDocumentComponentService(gSheetSection);
        }
        resolve("success");
      })
      .catch(error => {
        console.debug("fetchGoogleWorkSheet =>", error);
        reject(error);
      });
  });

export const checkGSheetStoreForData = sectionID => {
  const reduxState = store.getState();
  const { gSheetRevvTables } = reduxState.GoogleSheetStore;
  const { components, connectedGSheetSections } = reduxState.DocumentStore;
  const gSheetSection =
    components && components[sectionID] ? components[sectionID].content : null;
  batch(() => {
    if (
      connectedGSheetSections.includes(sectionID) &&
      !Object.prototype.hasOwnProperty.call(gSheetRevvTables, sectionID)
    ) {
      store.dispatch({
        type: "UPDATE_GSHEET_TABLES",
        payload: {
          sectionID,
          tableSection: gSheetSection,
        },
      });
    }
    setCurrentGSheetTab(gSheetSection);
  });
};

export const clearSelectedGSheetData = () => dispatch => {
  batch(() => {
    dispatch({
      type: "CURRENT_G_SHEET",
      payload: {},
    });
    dispatch({
      type: "CURRENT_G_WORK_SHEET",
      payload: "",
    });
  });
};

export const reUpdateWorkSheetOptions = reUpdateKey => dispatch => {
  dispatch({
    type: "REUPDATE_WORKSHEET_OPTIONS",
    payload: reUpdateKey,
  });
};

export const makeEmptyRange = () => dispatch => {
  const reduxState = store.getState();
  const { currentGSheetTab } = reduxState.GoogleSheetStore;
  currentGSheetTab.rangeValue = "";
  dispatch({
    type: "MAKE_EMPTY_RANGE",
    payload: currentGSheetTab,
  });
};

export const updatefirstRowAsHeaderKey = value => dispatch => {
  const reduxState = store.getState();
  const { currentGSheetTab } = reduxState.GoogleSheetStore;
  currentGSheetTab.firstRowAsHeader = value;
  dispatch({
    type: "UPDATE_FIRST_ROW_AS_HEADER_KEY",
    payload: currentGSheetTab,
  });
};



// WEBPACK FOOTER //
// ./src/actions/GoogleSheetActions/googleSheetActions.js